var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24219 2V16M15.2422 2V16M1.24219 5H5.24219M15.2422 5H19.2422M1.24219 13H5.24219M15.2422 13H19.2422M1.24219 9H19.2422M4.44219 17H16.0422C17.1623 17 17.7223 17 18.1502 16.782C18.5265 16.5903 18.8325 16.2843 19.0242 15.908C19.2422 15.4802 19.2422 14.9201 19.2422 13.8V4.2C19.2422 3.0799 19.2422 2.51984 19.0242 2.09202C18.8325 1.71569 18.5265 1.40973 18.1502 1.21799C17.7223 1 17.1623 1 16.0422 1H4.44219C3.32208 1 2.76203 1 2.33421 1.21799C1.95788 1.40973 1.65192 1.71569 1.46017 2.09202C1.24219 2.51984 1.24219 3.07989 1.24219 4.2V13.8C1.24219 14.9201 1.24219 15.4802 1.46017 15.908C1.65192 16.2843 1.95788 16.5903 2.33421 16.782C2.76203 17 3.32208 17 4.44219 17Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilm);
export default __webpack_public_path__ + "static/media/film.da97a651eb9bc7a4cfe083f9aa4015ad.svg";
export { ForwardRef as ReactComponent };